import React from 'react';
import { motion } from 'framer-motion';
import { FaFutbol, FaGraduationCap, FaTrophy, FaUsers, FaCalendarAlt, FaMapMarkerAlt, FaPlay, FaStar, FaMedal, FaHandshake, FaGlobe, FaClock, FaCheck, FaSearch } from 'react-icons/fa';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CountdownTimer from '../../components/CountdownTimer';
import bgImage from '../../assets/img/pictures/tttt.jpg';

const Departments = () => {
  const stats = [
    { number: "25+", label: "Years Experience", icon: <FaCalendarAlt /> },
    { number: "1000+", label: "Graduates", icon: <FaGraduationCap /> },
    { number: "20+", label: "Years of Excellence", icon: <FaTrophy /> },
    { number: "3", label: "Education Levels", icon: <FaUsers /> }
  ];

  const programs = [
    {
      title: "Foundation Stage",
      age: "U9 - U11",
      description: "Building fundamental skills and love for the game",
      icon: <FaFutbol />,
      color: "blue",
      image: require("../../assets/img/pictures/WhatsApp Image 2025-03-23 at 21.34.58_0c95330e.jpg")
    },
    {
      title: "Youth Development",
      age: "U12 - U16",
      description: "Technical and tactical development",
      icon: <FaGraduationCap />,
      color: "green",
      image: require("../../assets/img/pictures/WhatsApp Image 2025-02-20 at 11.10.09_a094888f.jpg")
    },
    {
      title: "Professional Development",
      age: "U17 - U21",
      description: "Advanced training for professional preparation",
      icon: <FaTrophy />,
      color: "red",
      image: require("../../assets/img/pictures/WhatsApp Image 2025-03-22 at 09.34.10_4e8f6024.jpg")

    }
  ];

  const achievements = [
    { number: "150+", label: "Professional Players", icon: <FaFutbol /> },
    { number: "25+", label: "National Team Players", icon: <FaMedal /> },
    { number: "50+", label: "Youth Championships", icon: <FaTrophy /> },
    { number: "1000+", label: "Academy Graduates", icon: <FaGraduationCap /> }
  ];

  const upcomingMatches = [
    {
      id: 1,
      homeTeam: "Kempshot U17",
      awayTeam: "Accra Youth FC",
      date: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000), // 5 days from now
      venue: "Kempshot Sports Complex",
      competition: "Youth League",
      kickoffTime: "15:00"
    },
    {
      id: 2,
      homeTeam: "Kempshot U15",
      awayTeam: "Legon City FC",
      date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 7 days from now
      venue: "Kempshot Sports Complex",
      competition: "Youth Cup",
      kickoffTime: "14:30"
    }
  ];

  const recentGames = [
    {
      id: 1,
      competition: "ASEMFA COLTS League",
      venue: "Opeikuma Park",
      date: "April 12, 2025",
      homeTeam: "U13 Korania",
      score: "0-5",
      awayTeam: "Kempshot FC U13",
      goals: [
        { team: "U13 Korania", scorer: "Own Goal", time: "15''" },
        { team: "Kempshot FC", scorer: "Joel Baafi", time: "35''" },
        { team: "Kempshot FC", scorer: "Joel Baafi", time: "40''" },
        { team: "Kempshot FC", scorer: "Joel Baafi", time: "45''" },
        { team: "Kempshot FC", scorer: "Derrick Asamanyoah", time: "50''" }
      ]
    },
    {
      id: 2,
      competition: "Youth League",
      venue: "Kempshot Sports Complex",
      date: "April 15, 2025",
      homeTeam: "U17 Korania",
      score: "0-0",
      awayTeam: "Kempshot FC U17",
      goals: []
    }
  ];

  return (
    <div className="min-h-screen relative">
      {/* Background Pattern */}
      <div className="fixed inset-0 z-0">
        <img
          src={bgImage}
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/95 via-blue-900/90 to-black/95"></div>
      </div>

      <div className="relative z-10">
        <Header />
        
        {/* Hero Section */}
        <section className="relative py-20 overflow-hidden">
          <div className="container mx-auto px-4">
            <div className="flex flex-col lg:flex-row items-center gap-12">
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                className="lg:w-1/2"
                >
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  Welcome to Kempshot Sports Academy
                  </h1>
                <p className="text-xl text-blue-100 mb-8">
                  Where champions are made. Established in 2024, we're building a legacy of excellence 
                  in football development and shaping the future of the beautiful game.
                </p>
                <div className="flex flex-wrap gap-4">
                  <motion.a
                    href="/auth/join"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-200"
                  >
                    Join Our Academy
                  </motion.a>
                  <motion.a
                    href="/auth/about"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-white/10 text-white px-8 py-3 rounded-full font-semibold hover:bg-white/20 transition-colors duration-200"
                  >
                    Learn More
                  </motion.a>
                </div>
                </motion.div>
                
              <motion.div 
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                className="lg:w-1/2"
              >
                <div className="relative">
                    <motion.img
                      src={require("../../assets/img/pictures/new image.jpg")}
                      alt="Academy Training"
                    className="rounded-2xl shadow-2xl w-full h-[400px] object-cover"
                      whileHover={{ scale: 1.02 }}
                      transition={{ duration: 0.3 }}
                    />
                    <motion.div 
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.5 }}
                    className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-4 rounded-lg shadow-lg"
                    >
                    <p className="text-sm font-semibold">Established 2024</p>
                    <p className="text-xs opacity-80">1+ Years of Excellence</p>
                    </motion.div>
                  </div>
                </motion.div>
              </div>
            </div>
          </section>

        {/* Stats Section */}
        {/* <section className="py-12 bg-white/5 backdrop-blur-sm">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center"
                >
                  <div className="text-3xl text-blue-400 mb-3">
                    {stat.icon}
                  </div>
                  <div className="text-3xl font-bold text-white mb-2">
                    {stat.number}
                  </div>
                  <div className="text-blue-100">
                    {stat.label}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Upcoming Matches Section */}
        <section className="py-12 sm:py-16">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-8 sm:mb-12"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">Upcoming Matches</h2>
              <p className="text-base sm:text-xl text-blue-100 max-w-2xl mx-auto">
                Don't miss our exciting upcoming fixtures
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
              {/* Coming Soon Feature */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center col-span-2"
              >
                <div className="text-4xl text-blue-400 mb-4">
                  <FaClock />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Match Schedule Coming Soon</h3>
                <p className="text-blue-100">We're working on bringing you the latest match schedule. Stay tuned!</p>
              </motion.div>

              {/* Commented out upcoming matches
              {upcomingMatches.map((match, index) => (
                <motion.div
                  key={match.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-8 border border-white/10 hover:border-white/20 transition-colors duration-300"
                >
                  <div className="flex flex-col items-center text-center mb-4 sm:mb-6">
                    <div className="flex items-center gap-2 text-blue-200 mb-2 text-sm sm:text-base">
                      <FaCalendarAlt className="text-blue-400" />
                      <span className="font-medium">{match.competition}</span>
                    </div>
                    <div className="flex items-center gap-2 text-blue-200 mb-3 sm:mb-4 text-sm">
                      <FaMapMarkerAlt className="text-blue-400" />
                      <span>{match.venue}</span>
                    </div>
                    <div className="bg-blue-600/20 rounded-lg px-3 sm:px-4 py-2 mb-4 sm:mb-6 w-full max-w-xs">
                      <div className="text-base sm:text-lg font-semibold text-white">
                        {match.date.toLocaleDateString('en-US', { 
                          weekday: 'long', 
                          month: 'long', 
                          day: 'numeric' 
                        })}
                      </div>
                      <div className="text-blue-200 text-sm">
                        Kick-off: {match.kickoffTime}
                      </div>
                    </div>
                    <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6 w-full justify-center">
                      <div className="text-center">
                        <h3 className="text-lg sm:text-xl font-bold text-white">{match.homeTeam}</h3>
                      </div>
                      <div className="px-3 sm:px-4 py-1 bg-blue-600/30 rounded-full text-white font-bold text-lg sm:text-xl">VS</div>
                      <div className="text-center">
                        <h3 className="text-lg sm:text-xl font-bold text-white">{match.awayTeam}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col items-center">
                    <div className="flex items-center gap-2 text-blue-200 mb-3 sm:mb-4 text-sm">
                      <FaClock className="text-blue-400" />
                      <span className="font-medium">Kick-off in:</span>
                    </div>
                    <CountdownTimer targetDate={match.date} />
                  </div>
                </motion.div>
              ))}
              */}
            </div>
          </div>
        </section>

        {/* Past Matches Section */}
        <section className="py-12 sm:py-16 bg-white/5 backdrop-blur-sm">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-8 sm:mb-12"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">Recent Results</h2>
              <p className="text-base sm:text-xl text-blue-100 max-w-2xl mx-auto">
                Catch up on our latest matches and performances
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
              {/* Coming Soon Feature */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center col-span-2"
              >
                <div className="text-4xl text-blue-400 mb-4">
                  <FaClock />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Match Details Coming Soon</h3>
                <p className="text-blue-100">We're working on bringing you detailed match information. Stay tuned!</p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Programs Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
                  <motion.div 
                    initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl font-bold text-white mb-4">Our Programs</h2>
              <p className="text-xl text-blue-100 max-w-2xl mx-auto">
                Comprehensive development programs designed to nurture talent at every stage
              </p>
            </motion.div>

            <div className="grid md:grid-cols-3 gap-8">
              {programs.map((program, index) => (
                <motion.div
                  key={program.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl overflow-hidden"
                >
                  <div className="relative h-48">
                    <img 
                      src={program.image}
                      alt={program.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
                      <div className="absolute bottom-4 left-4">
                        <h3 className="text-xl font-bold text-white">{program.title}</h3>
                        <p className="text-blue-200">{program.age}</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className={`text-4xl text-${program.color}-400 mb-4`}>
                      {program.icon}
                    </div>
                    <p className="text-blue-100">{program.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Achievements Section */}
        {/* <section className="py-16 bg-white/5 backdrop-blur-sm">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl font-bold text-white mb-4">Our Achievements</h2>
              <p className="text-xl text-blue-100 max-w-2xl mx-auto">
                Celebrating success and excellence in football development
              </p>
            </motion.div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {achievements.map((achievement, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center"
                >
                  <div className="text-3xl text-blue-400 mb-3">
                    {achievement.icon}
                  </div>
                  <div className="text-3xl font-bold text-white mb-2">
                    {achievement.number}
                  </div>
                  <div className="text-blue-100">
                    {achievement.label}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Gallery Section */}
        <section className="py-12 sm:py-16">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-8 sm:mb-12"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">Gallery</h2>
              <p className="text-base sm:text-xl text-blue-100 max-w-2xl mx-auto">
                Capturing our academy's journey through moments
              </p>
            </motion.div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
              {[
                require("../../assets/img/pictures/WhatsApp Image 2025-02-27 at 21.45.52_fdc9a380.jpg"),
                require("../../assets/img/pictures/WhatsApp Image 2025-02-23 at 12.50.39_1e9f352b.jpg"),
                require("../../assets/img/pictures/WhatsApp Image 2025-03-02 at 15.40.43_a725256c.jpg"),
                require("../../assets/img/pictures/WhatsApp Image 2025-03-02 at 20.09.39_28e1fb2e.jpg"),
                require("../../assets/img/pictures/WhatsApp Image 2025-03-02 at 21.24.03_3d051f18.jpg"),
                require("../../assets/img/pictures/WhatsApp Image 2025-03-29 at 22.39.13_bad4db03.jpg"),
                require("../../assets/img/pictures/WhatsApp Image 2025-02-16 at 14.27.23_ec00716f.jpg"),
                require("../../assets/img/pictures/new image.jpg")
              ].map((image, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="group relative aspect-square overflow-hidden rounded-xl cursor-pointer"
                >
                  <img
                    src={image}
                    alt={`Gallery ${index + 1}`}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-white text-sm sm:text-base font-semibold">Training Session</h3>
                      <p className="text-blue-200 text-xs sm:text-sm">March 2024</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Recent Highlights Section */}
        <section className="py-12 sm:py-16 bg-white/5 backdrop-blur-sm">
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-8 sm:mb-12"
            >
              <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">Recent Highlights</h2>
              <p className="text-base sm:text-xl text-blue-100 max-w-2xl mx-auto">
                Watch our latest moments of excellence
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              {/* Coming Soon Feature */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center col-span-full"
              >
                <div className="text-4xl text-blue-400 mb-4">
                  <FaClock />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Highlights Coming Soon</h3>
                <p className="text-blue-100">We're working on bringing you exciting highlights and moments from our academy. Stay tuned!</p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gradient-to-r from-blue-900/50 to-black/50 backdrop-blur-sm">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                {/* Player Trials CTA */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/10 hover:border-white/20 transition-colors duration-300"
                >
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center">
                      <FaFutbol className="text-2xl text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-white">Upcoming Trial</h3>
                  </div>
                  <p className="text-blue-100 mb-6">
                    Join our elite academy and take the first step towards your professional football career. 
                    Our comprehensive training program is designed to develop your skills and potential.
                  </p>
                  <div className="space-y-4">
                    <div className="flex items-center gap-2 text-blue-100">
                      <FaCheck className="text-green-400" />
                      <span>Professional Training</span>
                    </div>
                    <div className="flex items-center gap-2 text-blue-100">
                      <FaCheck className="text-green-400" />
                      <span>Expert Coaches</span>
                    </div>
                    <div className="flex items-center gap-2 text-blue-100">
                      <FaCheck className="text-green-400" />
                      <span>Career Development</span>
                    </div>
                  </div>
                  <motion.a
                    href="/auth/register"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="inline-block mt-6 px-8 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200"
                  >
                    Register for Trial
                  </motion.a>
                </motion.div>

                {/* Scout Registration CTA */}
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                  className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/10 hover:border-white/20 transition-colors duration-300"
                >
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 rounded-full bg-green-600 flex items-center justify-center">
                      <FaSearch className="text-2xl text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-white">Scout Registration</h3>
                  </div>
                  <p className="text-blue-100 mb-6">
                    Join our elite scouting network and help discover the next generation of football talent. 
                    Be part of our mission to develop future stars.
                  </p>
                  <div className="space-y-4">
                    <div className="flex items-center gap-2 text-blue-100">
                      <FaCheck className="text-green-400" />
                      <span>Global Network</span>
                    </div>
                    <div className="flex items-center gap-2 text-blue-100">
                      <FaCheck className="text-green-400" />
                      <span>Professional Development</span>
                    </div>
                    <div className="flex items-center gap-2 text-blue-100">
                      <FaCheck className="text-green-400" />
                      <span>Advanced Tools</span>
                    </div>
                  </div>
                  <motion.a
                    href="/auth/register-scout"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="inline-block mt-6 px-8 py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors duration-200"
                  >
                    Register as Scout
                  </motion.a>
                </motion.div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Departments;